import React from "react";
import FundList from "./FundList";
import AreasOfNeed from "./AreasOfNeed";
import SearchBar from "./SearchBar";
import FeaturedCauses from "./FeaturedCauses";
import Breadcrumbs from "./Breadcrumbs";
import Header from "./Header";
import { useAppContext } from "../hooks/useAppContext";
import CustomDesignation from "./CustomDesignation";
import { useLocation } from 'react-router-dom'

const FundCategory = ({ fundCategoryId, setFundCategoryId }) => {
  const location = useLocation();
  const catId = location.state ? location.state.catId : fundCategoryId;
  const [subcategories, setSubcategories] = React.useState([]);
  const [fundsPage, setFundsPage] = React.useState(0);
  const [fundsPager, setFundsPager] = React.useState(null);
  const [searchCatOptions, setSearchCatOptions] = React.useState([]);
  const [featuredCauses, setFeaturedCauses] = React.useState([]);
  const [breadcrumbs, setBreadcrumbs] = React.useState([]);
  const [categoryInfo, setCategoryInfo] = React.useState({});

  const { search, setSearch, setFunds } = useAppContext();

  React.useEffect(() => {
    let adminLinks = document.getElementsByClassName("menu-local-task");
    if (adminLinks.length > 0) {
      adminLinks.forEach((element) => {
        let newPath = element.getAttribute("data-drupal-link-system-path");
        let res = newPath.split("/");
        res[2] = catId;
        newPath = res.join("/");
        const getUrl = window.location;
        const baseUrl = getUrl.protocol + "//" + getUrl.host + "/";
        element.setAttribute("href", baseUrl + newPath);
      });
    }
  }, [fundCategoryId]);

  return (
    <>
      <div className="fund-category__wrapper">
        <Header categoryInfo={categoryInfo}>
          <Breadcrumbs breadcrumbs={breadcrumbs} search={search} />
          <SearchBar
            searchCatOptions={searchCatOptions}
            setSearchCatOptions={setSearchCatOptions}
            setFunds={setFunds}
            fundCategoryId={catId}
            setFundCategoryId={setFundCategoryId}
            setSearch={setSearch}
          />
        </Header>
        <div className="fund-category__content coh-container coh-container-boxed coh-style-padding-top---medium">
          <FeaturedCauses
            search={search}
            featuredCauses={featuredCauses}
            setFeaturedCauses={setFeaturedCauses}
            fundCategoryId={catId}
          />
          <AreasOfNeed
            setCategoryInfo={setCategoryInfo}
            setBreadcrumbs={setBreadcrumbs}
            search={search}
            subcategories={subcategories}
            setSubcategories={setSubcategories}
            fundCategoryId={catId}
            setFundsPage={setFundsPage}
          />
          <FundList
            fundsPager={fundsPager}
            setFundsPager={setFundsPager}
            fundsPage={fundsPage}
            setFundsPage={setFundsPage}
            fundCategoryId={catId}
            categoryInfo={categoryInfo}
          />
          <CustomDesignation></CustomDesignation>
        </div>
      </div>
    </>
  );
};

export default FundCategory;
